/**
 * Lightweight home featured strip — keep titles here so Home does not pull
 * the full blogPosts.js (~100KB+) into the main bundle.
 */
export const HOME_FEATURED_POSTS = [
  {
    slug: 'free-cfa-level-1-mock-exam-2026',
    title: 'Free CFA Mock Exam: Timed Level 1 Mock 1',
  },
  {
    slug: 'cfa-level-1-practice-questions-free',
    title: 'Free CFA Level 1 Practice Questions + Answers (2026)',
  },
  {
    // Guide page, not a post: the fee post 301s here (public/_redirects).
    slug: 'cfa-level-1-exam-fees',
    path: '/cfa-level-1-exam-fees/',
    title: 'CFA Level 1 Fees 2027: USD 1,140 Early, USD 1,490 Standard',
  },
  {
    slug: 'cfa-level-1-february-2027-deadlines-fees',
    title: 'CFA Level 1 Feb 2027 Registration: Closes 5 Nov, USD 1,490',
  },
  {
    slug: 'cfa-level-2-exam-dates-2026',
    title: 'CFA Level 2 Exam Dates 2026–2027 (Next: Nov 18–22)',
  },
  {
    slug: 'cfa-level-3-exam-dates-2026',
    title: 'CFA Level 3 Exam Dates 2026–2027 (Next: Feb 18–21)',
  },
  {
    slug: 'cfa-level-1-exam-dates-2026',
    title: 'CFA Level 1 Exam Dates 2026–2027: Feb 22–28, Apply by 5 Nov',
  },
  {
    slug: 'cfa-level-2-mock-exam-2026',
    title: 'CFA Level 2 Mock Exam 2026 | Timed Item-Set Practice',
  },
  {
    slug: 'cfa-level-3-mock-exam-2026',
    title: 'CFA Level 3 Mock Exam 2026 | Mixed Item Sets + Essays',
  },
  {
    slug: 'cfa-all-levels-lifetime-package-349',
    title: 'CFA L1+L2+L3 Lifetime Package — $349 (List $499)',
  },
];

/** Blog post with worked sample questions (one per lesson below). */
export const SAMPLE_QUESTIONS_POST_PATH = '/blog/cfa-level-1-practice-questions-free';

/** Study-guide lessons that have a worked question in the sample-questions post. */
export const SAMPLE_QUESTION_LESSON_PATHS = [
  '/study-guide/quantitative-methods/time-value-of-money-in-finance',
  '/study-guide/ethical-and-professional-standards/guidance-for-standards-i-vii',
  '/study-guide/fixed-income/yield-based-bond-duration-measures-and-properties',
  '/study-guide/financial-reporting-and-analysis/analyzing-statements-of-cash-flows-i',
  '/study-guide/portfolio-management-and-wealth-planning/portfolio-risk-and-return-part-ii',
];
